import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabGroupConfig, Props } from '../../model/form.model';
import { PageContainerComponent } from '../page-container/page-container.component';
import { BreadcrumsComponent } from '../../components/breadcrums/breadcrums.component';
import { breadrums } from '../../model/breadcrum.model';
import { LAYOUT_TYPE } from '../../model/common.model';

@Component({
  selector: 'app-grouped-page-container',
  standalone: true,
  imports: [CommonModule, PageContainerComponent, BreadcrumsComponent],
  templateUrl: './grouped-page-container.component.html',
  styleUrl: './grouped-page-container.component.scss',
})
export class GroupedPageContainerComponent {
  @Input() groups: TabGroupConfig[] = [];
  @Input() title = '';
  @Input() showBreadcrumb = true;
  @Input() props: Props = { isTabStretch: true };

  readonly LayoutType = LAYOUT_TYPE;
  selectedGroupIndex = 0;
  @Output() groupChange = new EventEmitter<number>();

  get breadcrumList(): breadrums[] {
    return this.title ? [{ level: 1, name: this.title }] : [];
  }

  onGroupChange = (index: number) => {
    this.selectedGroupIndex = index;
    this.groupChange.emit(index);
  };
}
